<template>
  <div class="msg-item">
    <div class="msg-header">
      <div class="dots">
      <span class="dot red"></span>
      <span class="dot yellow"></span>
      <span class="dot green"></span>
      </div>
      <span class="nickname">{{ message.nickname }}</span>
      <span class="time">{{ message.time }}</span>
    </div>
    <div class="msg-content" @click="onDetail">{{ message.content }}</div>
    <div v-if="hasComment" class="comment-line"></div>
    <div v-if="hasComment" class="msg-comment-list">
      <div v-for="(c, i) in message.comments" :key="i" class="msg-comment">
        <span class="comment-nick">{{ c.nickname }}：</span>
        <span class="comment-content">{{ c.content }}</span>
      </div>
    </div>
    <div class="msg-actions">
      <div class="action-like" @click.stop="onLike">
        <van-icon :name="isLiked ? 'like' : 'like-o'" :color="isLiked ? '#f3b6ca' : '#9ca3af'" size="20" />
        <span class="action-num">
          <template v-if="likeUsers && likeUsers.length">
            <span v-for="(user, idx) in likeUsers" :key="user.userId" class="like-nick">
              {{ user.nickname }}<span v-if="idx !== likeUsers.length - 1">、</span>
            </span>
          </template>
        </span>
      </div>
      <div class="action-comment" @click.stop="toggleCommentInput">
        <van-icon name="chat-o" color="#b2b8c2" size="20" />
        <span class="action-num">{{ message.comments.length }}</span>
      </div>
    </div>
    <transition name="slide-fade">
      <div v-if="showCommentInput" class="comment-input-wrap">
        <van-field
          v-model="commentContent"
          placeholder="写下你的评论..."
          class="comment-input"
        />
        <van-button
          size="small"
          type="primary"
          round
          class="comment-btn"
          @click="handleComment"
        >
          发送
        </van-button>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'MessageItem',
  props: {
    message: { type: Object, required: true }
  },
  data () {
    return {
      showCommentInput: false,
      commentContent: ''
    }
  },
  computed: {
    hasComment () {
      return this.message.comments && this.message.comments.length > 0
    },
    likeUsers () {
      const arr = this.message.likeUsers || []
      return arr
        .filter(u => u && u.nickname)
        .filter((u, idx, self) => idx === self.findIndex(x => String(x.userId) === String(u.userId)))
    },
    isLiked () {
      const userId = localStorage.getItem('userId')
      return this.likeUsers.some(u => String(u.userId) === String(userId))
    }
  },
  methods: {
    onLike () {
      this.$emit('like', this.message)
    },
    onDetail () {
      this.$emit('detail', this.message)
    },
    toggleCommentInput () {
      this.showCommentInput = !this.showCommentInput
      if (this.showCommentInput) {
        this.commentContent = ''
      }
    },
    handleComment () {
      if (!this.commentContent.trim()) {
        this.$toast('请输入评论内容')
        return
      }
      this.$emit('comment', { message: this.message, content: this.commentContent.trim() })
      this.commentContent = ''
      this.showCommentInput = false
      this.$toast('评论成功！')
    }
  }
}
</script>

<style scoped>
.msg-item {
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(16px) saturate(180%);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.4);
  box-shadow:
    0 4px 24px rgba(0, 0, 0, 0.08),
    0 2px 8px rgba(0, 0, 0, 0.04),
    inset 0 1px 0 rgba(255, 255, 255, 0.6);
  padding: 20px;
  margin-bottom: 16px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
}

.msg-item:hover {
  transform: translateY(-2px);
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.12),
    0 4px 16px rgba(0, 0, 0, 0.06),
    inset 0 1px 0 rgba(255, 255, 255, 0.7);
}

.msg-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 6px;           /* 点 与 昵称 的间距 */
  justify-content: flex-start;  /* 关键：左对齐，别用 space-between */
}

.nickname {
  color: #667eea;
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.time {
  color: #9ca3af;
  font-size: 0.85rem;
  font-weight: 400;
  margin-left: auto;  /* 关键：把时间推到最右侧 */
}

.msg-content {
  color: #2d3748;
  font-size: 1rem;
  line-height: 1.6;
  margin-top: 6px;
  margin-bottom: 16px;
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.comment-line {
  height: 1px;
  background: linear-gradient(to right, transparent, rgba(160, 174, 192, 0.3), transparent);
  margin: 0 0 12px 0;
}

.msg-comment-list {
  margin-bottom: 2px;
  padding: 12px;
  background: rgba(247, 250, 252, 0.4);
  border-radius: 12px;
  backdrop-filter: blur(8px);
}

.msg-comment {
  font-size: 0.89rem;
  color: #4a5568;
  margin-bottom: 6px;
  line-height: 1.5;
}

.msg-comment:last-child {
  margin-bottom: 0;
}

.comment-nick {
  color: #8b919c;
  font-weight: 600;
  margin-right: 4px;
}

.comment-content {
  color: #9ca3af;
}

.msg-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding-top: 12px;
  border-top: 1px solid rgba(160, 174, 192, 0.15);
}

.action-like,
.action-comment {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  user-select: none;
  padding: 6px 12px;
  border-radius: 20px;
  transition: all 0.2s ease;
}

.action-like:hover {
  background: rgba(244, 143, 177, 0.1);
}

.action-comment:hover {
  background: rgba(156, 163, 175, 0.1);
}

.action-like:active,
.action-comment:active {
  transform: scale(0.95);
}

.action-num {
  font-size: 0.85rem;
  color: #b2b8c2;
  font-weight: 500;
}

.like-nick {
  color: #f3b6ca;
  font-weight: 500;
  font-size: 0.85rem;
}

.comment-input-wrap {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
  padding: 12px;
  background: rgba(247, 250, 252, 0.8);
  border-radius: 12px;
  backdrop-filter: blur(8px);
}

::v-deep .comment-input {
  background: rgba(255, 255, 255, 0.8);
  border-radius: 8px;
  border: 1px solid rgba(160, 174, 192, 0.2);
  padding: 8px 12px;
  font-size: 0.9rem;
}

::v-deep .comment-input .van-field__control {
  color: #2d3748;
  min-height: 32px;
}

::v-deep .comment-input:focus-within {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.comment-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  color: white;
  font-weight: 500;
  font-size: 0.85rem;
  min-width: 60px;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(10px);
  opacity: 0;
}

/* 响应式设计 */
@media (max-width: 600px) {
  .msg-item {
    padding: 16px;
    margin-bottom: 12px;
  }

  .msg-actions {
    gap: 20px;
  }

  .action-like,
  .action-comment {
    padding: 4px 8px;
  }
}

.msg-header {
  display: flex;
  align-items: center;
  gap: 8px; /* 控制 dots 与昵称之间的距离 */
}

.dots {
  display: flex;
  align-items: center;
  gap: 6px; /* 三个点之间的间距 */
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
}

.red {
  background-color: #f48fb1;
}

.yellow {
  background-color: #ffbd2e;
}

.green {
  background-color: #27c93f;
}

</style>
